export default {
  methods: {
    routerPushHome () {
      this.$router.push('/').catch(error => {
        if (
          error.name !== 'NavigationDuplicated' &&
          !error.message.includes('Avoided redundant navigation to current location')
        ) {
          console.error(error)
        }
      })
    },
    formatPriceWithCode (rawPrice, currency) {
      if (!currency) return rawPrice

      return new Intl.NumberFormat(
        this.$i18n.locale,
        {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'code'
        }).format(rawPrice)
    },

    formatPriceWithNarrowSymbol (rawPrice, currency) {
      if (!currency) return rawPrice

      return new Intl.NumberFormat(
        this.$i18n.locale,
        {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'narrowSymbol'
        }).format(rawPrice)
    }
  }
}
